import axios from 'axios';
import Vue from 'vue';
import CONFIG from 'config';
import { LANG } from 'config/variable';
import md5 from 'md5';

import { getCookie } from 'js/utils';
const SERVER_ENV = window.lang_env; // 服务端语言
// 创建axios实例

const lang = LANG[SERVER_ENV]; // ajax请求带的语言参数

const service = axios.create({
  baseURL: CONFIG.adminBaseUrl, // api的base_url
  timeout: 15000, // 请求超时时间
  withCredentials: true,
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  params: {
    lang,
    _ajax: 1
  }
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    let newConfig = config;
    let skey = getCookie('skey') || localStorage.getItem('skey');
    let token = getCookie('token') || localStorage.getItem('token');
    skey = skey ? md5(skey).substring(0, 10) : '';
    let url = config.url;
    if (skey) {
      url = `${url}?skey=${skey}`;
    }
    if (token) {
      url += `&_token_=${token}`;
    }
    newConfig.url = url;
    return newConfig;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  response => {
    if (response.headers['content-type'] === 'image/svg+xml') {
      return response.data;
    }
    let vm = new Vue();
    if (response.status === 200) {
      const res = response.data;
      if (res.code === CONFIG.RES_OK) {
      } else if (res.code === 10009) {
        vm.$toast(res.msg);
        window.location = './#/login';
      } else {
        vm.$toast(res.msg);
      }
      return response.data;
    }
    return Promise.reject(new Error('error'));
  },
  error => {
    return Promise.reject(new Error(error));
  }
);
export default service;
